<div class="row justify-content-center p-5" *ngIf="loadingSignal">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>

<div class="row p-2" *ngIf="!isWorldWatch_User">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">
      <div style="padding: 1rem; border-color: #ff0000 !important; border: 0.125rem solid transparent;">
        <div><h3>{{ 'pages.worldwatch.noAccess.heading' | translate }}</h3></div>
        <div><p [innerHTML]="'pages.worldwatch.noAccess.body' | translate"></p></div>
      </div>
    </div>
  </div>

<div class="row" *ngIf="signal">
    <div class="col-xl-1 col-lg-1 d-none d-lg-block">&nbsp;</div>
    <div class="col-xl-10 col-lg-10 col-md-12">

        <div class="row">
            <div class="col-12 signalicon-headingleft" [ngClass]="signal.signalUrgency + signal.mainCategory | lowercase | removeWhiteSpace"><h2>{{signal.summary}}</h2></div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.reference' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"><b>{{signal.jiraRef}}</b></div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"><b>{{signal.signalUrgency | uppercase}}</b></div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.mainCategory' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"><b>{{signal.mainCategory | uppercase}}</b></div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.categories' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12 ">
                <div *ngFor="let s of signal.categories">
                    {{s.value}}
                </div>
                <span *ngIf="!signal.categories">N/A</span>
            </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.lastUpdate' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">{{signal.date | date: 'dd/MM/yyyy HH:mm'}} GMT</div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.executiveSummary' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.executiveSummary | safeHtml"></span>
                <span *ngIf="!signal.executiveSummary">N/A</span>
            </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.whatYouWillHear' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.whatYouWillHear | safeHtml"></span>
                <span *ngIf="!signal.whatYouWillHear">N/A</span>
            </div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.whatItMeans' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.whatItMeans | safeHtml"></span>
                <span *ngIf="!signal.whatItMeans">N/A</span>
            </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.whatWeAreDoing' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <div *ngIf="signal.servicesAffected">						
                    {{ 'pages.updates.signal.fieldTitles.servicesConsumedPre' | translate }}<br/>
                    <span *ngFor="let s of signal.servicesAffected" class="pl-2 highlight">
                        <li>{{s.value}}</li>
                    </span>
                    <br/>
                    {{ 'pages.updates.signal.fieldTitles.servicesConsumedPost' | translate }}
                    <br/><br/>
                </div>
                <span class="preserve-whitespace" [innerHTML]="signal.whatWeAreDoing | safeHtml"></span>
                <span *ngIf="!signal.whatWeAreDoing">N/A</span>
            </div>
        </div>
        <div class="row p-1" style="background-color: #F3F3F3;;">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5> {{ 'pages.updates.signal.fieldTitles.whatYouShouldDo' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.whatYouShouldDo | safeHtml"></span>
                <span *ngIf="!signal.whatYouShouldDo">N/A</span>
            </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5> {{ 'pages.updates.signal.fieldTitles.readMore' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.readMore | linkify | safeHtml"></span>
                <span *ngIf="!signal.readMore">N/A</span>
            </div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5> {{ 'pages.updates.signal.fieldTitles.geopoliticalComments' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" *ngIf="signal.geopoliticalComments" [innerHTML]="signal.geopoliticalComments | safeHtml"></span>
                <span *ngIf="!signal.geopoliticalComments">N/A</span>
            </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.iocFull' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <span class="preserve-whitespace" [innerHTML]="signal.ioc | safeHtml"></span>
                <span *ngIf="!signal.ioc">N/A</span>
            </div>
        </div>
        <div class="row p-1">
          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.tags' | translate }}</h5></div>
          <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <div *ngFor="let s of signal.tags">
                <li>
                    <a [routerLink]="['/updates/worldwatch/viewTag/' + s]" routerLinkActive="router-link-active">{{s}}</a>
                </li>
            </div>  
          </div>
        </div>
        <div class="row p-1 banding">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.updates' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12">
                <div class="preserve-whitespace" *ngFor="let s of signal.comments">
                    {{s.comment}}<br/>
                    <small class="text-muted">{{s.author}} - {{ s.date | date:'dd/MM/yyyy HH:mm'}}</small><br/>
                </div>
            </div>
        </div>
        <div class="row p-1" *ngIf="signal.closingComments">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.updates.signal.fieldTitles.closingComments' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"><span class="preserve-whitespace" [innerHTML]="signal.closingComments | safeHtml"></span></div>
        </div>
        <div class="row p-1">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"><h5>{{ 'pages.generic.downloadPDF' | translate }}</h5></div>
            <div class="col-xl-9 col-lg-8 col-md-8 col-sm-6 col-xs-12"><img src="../../../assets/images/icons/pdf.png" alt="PDF document icon" class="click" (click)="downloadPDF()" /><br/></div>
        </div>
        <div class="row pt-3">
            <div class="col-12 p-1 pl-3">
                <fa-icon [icon]="['fas', 'eye']" class="p-1" (click)="likeSignal()"></fa-icon>
                <span style="font-style: italic;" *ngIf="signal.viewCount">{{signal.viewCount}} views</span>
                <span style="font-style: italic;" *ngIf="!signal.viewCount">0 {{ 'pages.generic.views' | translate }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 p-1 pl-3">
                <fa-icon [icon]="['fas', 'thumbs-up']" class="p-1 click" (click)="likeSignal()"></fa-icon>
                <span style="font-style: italic;" *ngIf="signal.likeCount">{{signal.likeCount}} {{ 'pages.updates.signal.fieldTitles.useful' | translate }}</span>
                <span style="font-style: italic;" *ngIf="!signal.likeCount">0 {{ 'pages.updates.signal.fieldTitles.useful' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="col-xl-1 col-lg-1 d-none d-lg-block">&nbsp;</div>
  </div>